import type { ReactNode } from 'react'
import { useScreenSize } from '@ztechapps/common.hook'

export type ShowOnScreenSizeProps = {
  breakingPoint?: number
  size: 'mobile' | 'desktop' | 'tablet'
  children: ReactNode
}
/**
 * Show only when screen size is mobile or desktop, the breaking point is 768px
 * @constructor
 */
export const ShowOnlyOnScreenSize = ({ breakingPoint, size, children }: ShowOnScreenSizeProps) => {
  const screenSize = useScreenSize({ breakingPoint })

  const isMobile = screenSize === 'mobile'
  const isDesktop = screenSize === 'desktop'

  if (isMobile && size === 'mobile') {
    return children
  }

  if (isDesktop && size === 'desktop') {
    return children
  }

  //return null if the screen size asking for mobile, but the actual width is more than 768 (default breaking point)
  //return also as null if the looking for desktop screen, but the actual screen size is less than 768
  return null
}
